<template>
  <div class="swiper-container home-swiper main-swiper" id="main-swiper">
    <div class="swiper-wrapper">
      <div
        class="swiper-slide swiper-no-swiping"
        v-for="(item, index) in bannerLists"
        :key="index"
        :style="{'background-image': 'url(' + item.image + ')'}"
      >
        <a
          class="bui-btn more-banner"
          :href="item.url"
          target="_blank"
          :ga-data="'10200'+(++index)"
        >
          <span>{{ $t('home.knowmore') }}</span>
          <div></div>
        </a>
      </div>
    </div>
    <div class="swiper-pagination" v-show="bannerLists.length > 1"></div>
    <div class="swiper-button-prev" v-show="bannerLists.length > 1"></div>
    <div class="swiper-button-next" v-show="bannerLists.length > 1"></div>
  </div>
</template>

<script>
import Swiper from "swiper";

export default {
  name: 'mswipe',
  props: [
    'bannerLists'
  ],
  mounted() {
    this.$nextTick(() => {
      new Swiper("#main-swiper", {
        loop: this.bannerLists.length > 1 ? true : false,
        autoplay: this.bannerLists.length > 1 ? 5000 : false,
        observer: true,
        observeParents: true,
        autoplayDisableOnInteraction: false,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        pagination: ".swiper-pagination"
      });
    });
  }
}
</script>

<style lang="scss" scoped>
.bui-btn {
  display: block;
  text-decoration: none;
  margin: 60px auto 60px;
  width: 170px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #50bbe5;
  border-radius: 100px;
  text-align: center;
  font-size: 0;
  cursor: pointer;
  span {
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    line-height: 40px;
    margin-right: 10px;
    vertical-align: middle;
  }
  div {
    display: inline-block;
    background-image: url("~@assetImages/home/arrow_right_green.svg");
    width: 12px;
    height: 12px;
    vertical-align: middle;
  }
  &:hover {
    background: #50bbe5;
    box-shadow: 0 4px 6px 0 rgba(10, 131, 186, 0.3);
    span {
      color: #ffffff;
    }
    div {
      background-image: url("~@assetImages/home/arrow_right_white.svg");
    }
  }
}
.more-banner {
  position: relative;
  top: 65%;
  left: 50%;
  margin-left: 460px;
  background: #50bbe5;
  &:hover {
    box-shadow: 0 4px 6px 0 rgba(10, 131, 186, 0.3);
  }
  span {
    color: #ffffff;
  }
  div {
    background-image: url("~@assetImages/home/arrow_right_white.svg");
  }
}
.home-swiper {
  &.home-swiper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .swiper-slide {
      width: 100%;
      height: 100%;
      // background-image: url("../../assets/images/home/pic_default.svg");
      background-color: #eee;
      @extend %bgContain;
    }
    .swiper-button-prev,
    .swiper-button-next {
      top: auto;
      bottom: 30px;
      left: 50%;
      width: 30px;
      height: 30px;
      @extend %bgContain;
      background-color: rgba(0, 0, 0, 0.4);
      border-radius: 50%;
    }
    .swiper-button-prev {
      background-image: url("~@assetImages/home/swiper_left.svg");
      margin-left: -170px;
      &:hover {
        background-image: url("~@assetImages/home/swiper_left_hover.svg");
      }
    }
    .swiper-button-next {
      background-image: url("~@assetImages/home/swiper_right.svg");
      margin-left: 140px;
      &:hover {
        background-image: url("~@assetImages/home/swiper_right_hover.svg");
      }
    }
    .swiper-pagination.swiper-pagination-bullets {
      font-size: 0;
      bottom: 41px;
      /deep/ .swiper-pagination-bullet {
        background: rgba(255, 255, 255, 0.4);
        &.swiper-pagination-bullet-active {
          background: #fff;
        }
      }
    }
  }
}
</style>